module.exports = __webpack_public_path__ + "static/img/sh_img_system.448a34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sh_img_system.png
// module id = 5fYu
// module chunks = 1